import React from "react";
import {Link} from "../../plugins/gatsby-plugin-atollon";
import {HelmetDatoCms} from "../../plugins/gatsby-plugin-atollon";
import {EdlynLogo} from "../components/icons";
import AnimationButton from "../components/structured-text/blocks/animation-button";

const NotFoundPage = () => {
    return (
        <>
            <HelmetDatoCms>
                <body className={`page-template page-template--error`}/>
            </HelmetDatoCms>
            <section className='error-404'>
                <div className='error-404__inner'>
                    <div className='error-404__wrapper'>
                        <Link to='/'><EdlynLogo/></Link>
                        <h1>Page not found</h1>
                        <p>Sorry, we can’t seem to find the page you’re looking for. Either it no longer exists, or
                            there may be a typo in your address.</p>
                        <div className='error-404__buttons'>
                            <AnimationButton className='btn btn--animation' to='/'>Return Home</AnimationButton>
                            <AnimationButton className='btn btn--animation' to='/contact-us'>Get in touch</AnimationButton>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default NotFoundPage
